import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import InvoiceTable from "./InvoiceTable";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import ReceivableService from "../../../services/ReceivableService";

import { useDispatch } from "react-redux";

import { reset } from "../../../store/receivableSlice";
import InvoiceIcon from "../../../components/Vectors/InvoiceIcon";
import DelendSearchIcon from "../../../components/Vectors/Icons/DelendSearchIcon";
import UploadFileDrawer from "./UploadFileDrawer";
import SignUpModal from "./RegisterModal";
import ReceivableHeader from "./components/ReceivableHeader";

const EmptyState: React.FC<{ handleDrawerOpen: () => void }> = ({
  handleDrawerOpen,
}) => {
  return (
    <React.Fragment>
      <Box
        sx={{
          padding: "100px 0px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <InvoiceIcon />

        <Typography
          sx={{ ml: 2, fontWeight: 600, mb: "16px", fontSize: 18, mt: "24px" }}
          color="inherit"
          noWrap
        >
          Você ainda não possui vendas registradas na plataforma
        </Typography>

        <Typography
          width={"564px"}
          align="center"
          sx={{
            ml: 2,
            fontWeight: 400,
            color: "#8087A6",
            fontSize: 16,
            mb: "24px",
          }}
          color="inherit"
        >
          Olá! Para começar a antecipar seus recebíveis precisamos registrar
          suas vendas. Clique no botão abaixo para importar as Notas Fiscais na
          plataforma e seguir os próximos passos.
        </Typography>
        <Button
          onClick={handleDrawerOpen}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderRadius: 50,
            color: "#820AD1",
            borderColor: "#E9EBF0",
            px: "16px",
            py: "10px",
            "&:hover": { color: "#fff", background: "#820AD1" },
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 14,
            }}
            color="inherit"
            noWrap
          >
            Importar Notas Fiscais
          </Typography>
        </Button>
      </Box>
    </React.Fragment>
  );
};

const ReceivablePage: React.FC = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [rows, setRow] = useState<any[]>([]);

  const [isFetched, setIsFetched] = useState(false);

  const [searchText, setSearchText] = useState<string | null>(null);

  const fetchReceivables = async () => {
    setIsFetched(false);
    const response = await ReceivableService.getAll();
    setIsFetched(true);
    if (response?.data?.receivables) {
      setRow(response.data.receivables);
    }
  };

  useEffect(() => {
    dispatch(reset());
    fetchReceivables();
  }, [dispatch]);

  const openDrawer = () => {
    setOpen(true);
  };

  const openModalFunction = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleDrawerClose = (imported: boolean) => {
    if (imported) {
      fetchReceivables();
    }
    setOpen(false);
  };

  if (!isFetched) {
    return <DelendCentralizedCircularProgress />;
  }

  const filterRows = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  return (
    <Box>
      <ReceivableHeader
        openDrawer={openDrawer}
        openModalFunction={openModalFunction}
      />
      <Paper
        variant="outlined"
        sx={{ padding: 0, borderRadius: "8px", marginTop: "32px" }}
      >
        <Grid container>
          <Grid
            sx={{
              height: 80,
              borderBottom: "1px solid #E9EBF0",
              paddingTop: "15px",
            }}
            item
            xs={12}
          >
            <Box display={"flex"} alignItems={"center"}>
              <TextField
                style={{ width: 350, marginLeft: 40, height: 40 }}
                InputProps={{
                  sx: {
                    fontSize: 13,
                    borderRadius: 50,
                    paddingLeft: "12px",
                    height: 40,
                  },
                  endAdornment: (
                    <InputAdornment position="start">
                      <DelendSearchIcon
                        style={{
                          cursor: "pointer",
                          marginTop: "4px",
                          marginLeft: "8px",
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder="Procure por Nº da NF ou CNPJ"
                onChange={filterRows}
              />
            </Box>
          </Grid>
          <Grid container item xs={12}>
            {isFetched && rows.length === 0 ? (
              <EmptyState handleDrawerOpen={openDrawer} />
            ) : (
              <InvoiceTable
                receivables={rows}
                searchText={searchText}
                openModalFunction={openModalFunction}
              />
            )}
            <SignUpModal open={openModal} onClose={handleModalClose} />
            <UploadFileDrawer
              openSideBar={open}
              handleDrawerClose={handleDrawerClose}
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ReceivablePage;
